import { Component, output } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { DisableInDemoModeDirective } from '../../../demo/directives/disable-in-demo-mode';

@Component({
  selector: 'app-documents-empty-box',
  imports: [Button, NgIcon, TranslocoPipe, DisableInDemoModeDirective],
  templateUrl: './documents-empty-box.html',
})
export class DocumentsEmptyBox {
  clickUpload = output();
}
